import { createRouter } from "@tanstack/react-router";
import { Route as RootRoute } from "./routes/__root";
import { Route as IndexRoute } from "./routes/index";
import { Route as LoginRoute } from "./routes/auth.login";
import { Route as CallbackRoute } from "./routes/auth.callback";
import { Route as InviteRoute } from "./routes/auth.invite";
import { Route as OrdersRoute } from "./routes/orders";
import { Route as OrdersNewRoute } from "./routes/orders.new.route";
import { Route as OrdersDetailRoute } from "./routes/orders.detail.route";
import { Route as OrdersEditRoute } from "./routes/orders.edit.route";
import { Route as RoutesRoute } from "./routes/routes.route";
import { Route as StatusRoute } from "./routes/status.route";
import { Route as StatusReadRoute } from "./routes/status.read";
import { Route as AlertsRoute } from "./routes/alerts";
import { Route as ReportsRoute } from "./routes/reports.route";
import { Route as WorkReportsRoute } from "./routes/work-reports.route";
import { Route as ExpensesRoute } from "./routes/expenses.route";
import { Route as AttendanceRoute } from "./routes/attendance.route";
import { Route as BillingRoute } from "./routes/billing.route";
import { Route as BillingNewRoute } from "./routes/billing.new.route";
import { Route as BillingDetailRoute } from "./routes/billing.detail.route";
import { Route as MastersClientsRoute } from "./routes/masters.clients.route";
import { Route as MastersDeliverySpotsRoute } from "./routes/masters.deliverySpots.route";
import { Route as MastersSitesRoute } from "./routes/masters.sites.route";
import { Route as MastersUsersRoute } from "./routes/masters.users";
import { Route as VehiclesRoute } from "./routes/vehicles.route";
import { Route as ParseJobsRoute } from "./routes/parse-jobs";
import { Route as NewsRoute } from "./routes/news";
import { Route as LineLogsRoute } from "./routes/line-logs";
import { Route as NotificationsRoute } from "./routes/notifications";
import { Route as SettingsRoute } from "./routes/settings.route";
import { Route as ProfileRoute } from "./routes/profile";
import type { RouterContext } from "./router-context";

const routeTree = RootRoute.addChildren([
  IndexRoute,
  LoginRoute,
  CallbackRoute,
  InviteRoute,
  OrdersRoute,
  OrdersNewRoute,
  OrdersDetailRoute,
  OrdersEditRoute,
  RoutesRoute,
  StatusRoute,
  StatusReadRoute,
  AlertsRoute,
  ReportsRoute,
  WorkReportsRoute,
  ExpensesRoute,
  AttendanceRoute,
  BillingRoute,
  BillingNewRoute,
  BillingDetailRoute,
  MastersClientsRoute,
  MastersDeliverySpotsRoute,
  MastersSitesRoute,
  MastersUsersRoute,
  VehiclesRoute,
  ParseJobsRoute,
  NewsRoute,
  LineLogsRoute,
  NotificationsRoute,
  SettingsRoute,
  ProfileRoute,
]);

export const router = createRouter({
  routeTree,
  context: { session: null, authLoading: true } satisfies RouterContext,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
